import * as React from 'react';

import * as styles from './style.css';

export const BookedPageFooter = (props: React.PropsWithChildren<{}>) => {
  return (
    <div className={styles['footer']}>
      <div className={styles['container']}>{props.children}</div>
    </div>
  );
};
